import createReducer from '../createReducer';

const initialState = {
    eventCategories:[],
    getCategoriesXHR:null,
};

const reducer = createReducer('categories',initialState);

export default reducer;